<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-system-order-types></table-system-order-types>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableSystemOrderTypes from './TableGrids/TableSystemOrderTypes.vue'

export default {
    name: 'SystemOrderTypes',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableSystemOrderTypes,
    },
    data() {
        return {
            page: {
                title: "Order Types",
            },
            breadcrumbs: [
                { text: "Order Types", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
